import { render, staticRenderFns } from "./ConsumptionDetail.vue?vue&type=template&id=5accd975&scoped=true&"
import script from "./ConsumptionDetail.vue?vue&type=script&lang=js&"
export * from "./ConsumptionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5accd975",
  null
  
)

export default component.exports